export default __webpack_public_path__ + "static/media/impayes.9e12c692.jpg";